import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationSubjectLabel',
  standalone: true
})
export class ApplicationSubjectLabelPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/zajecie-pasa-prowadzenie-robot': {
        return 'Ulica, której dotyczy zajęcie pasa:';
      }
      case application?.service?.url === '/wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp': {
        return 'Rodzaj wniosku:';
      }
      case application?.service?.url === '/decyzja-o-warunkach-zabudowy': {
        return 'Rodzaj wniosku';
      }
      default: {
        return 'Wniosek dotyczy:';
      }
    }
  }
}
